(function () {
  'use strict';
  if (customElements.get('ho-style-finder')) return;
  let catalogueRequest;
  const availabilityRequests = new Map();
  const stateKey = 'ho-native-finder-state-v4';
  const maxQuestions = 4;
  const scrollKey = 'ho-native-finder-scroll';
  const pageKey = href => {
    const url = new URL(href, window.location.origin);
    url.searchParams.delete('preview_theme_id');
    url.searchParams.sort();
    return url.pathname + url.search;
  };
  const readState = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch (_) { return null; } };
  const saveState = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {} };
  const clearState = key => { try { sessionStorage.removeItem(key); } catch (_) {} };
  const scrollToProducts = () => {
    const target = document.querySelector('.productgrid--wrapper') || document.querySelector('[data-productgrid-outer]');
    if (!target) return;
    const header = document.querySelector('[data-site-header], .site-header, .shopify-section-header');
    const headerRect = header?.getBoundingClientRect();
    const offset = headerRect && headerRect.top <= 0 && headerRect.bottom > 0 ? Math.min(headerRect.bottom, 240) + 16 : 20;
    let focusTarget = target.querySelector('[data-ho-results-focus]');
    if (!focusTarget) {
      focusTarget = document.createElement('p');
      focusTarget.dataset.hoResultsFocus = '';
      focusTarget.className = 'ho-results-focus';
      focusTarget.tabIndex = -1;
      focusTarget.textContent = document.querySelector('ho-style-finder [data-sf-results-label]')?.textContent || 'Matching products';
      target.prepend(focusTarget);
    }
    focusTarget.focus({ preventScroll: true });
    window.scrollTo({ top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  };
  const pending = readState(scrollKey);
  if (pending && pending.page === pageKey(window.location.href)) {
    clearState(scrollKey);
    if (document.readyState === 'complete') requestAnimationFrame(scrollToProducts);
    else window.addEventListener('load', scrollToProducts, { once: true });
  }
  customElements.define('ho-style-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.copy = JSON.parse(this.querySelector('[data-sf-copy]').textContent);
      this.disclosure = this.querySelector('details');
      this.body = this.querySelector('[data-sf-body]');
      this.toggleLabel = this.querySelector('[data-sf-toggle]');
      this.summary = this.querySelector('summary');
      this.answers = {};
      this.history = [];
      this.checkpoints = [];
      this.routeFamily = null;
      this.step = 0;
      this.applied = false;
      this.requestId = 0;
      this.saved = readState(stateKey);
      if (this.saved && this.saved.page !== pageKey(window.location.href)) this.saved = null;
      this.disclosure.addEventListener('toggle', () => {
        this.toggleLabel.textContent = this.disclosure.open ? this.copy.close : this.copy.open;
        if (this.disclosure.open && !this.catalogue) this.load();
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-sf-action]');
        if (!button || !this.contains(button)) return;
        const action = button.dataset.sfAction;
        if (action === 'close') { this.disclosure.open = false; this.summary.focus({ preventScroll: true }); return; }
        if (action === 'retry') { this.load(); return; }
        if (action === 'products') {
          if (this.familyMode && this.styleConfig) window.location.assign(this.baseUrl());
          else scrollToProducts();
          return;
        }
        if (action === 'category') {
          this.requestId++;
          this.routeFamily = button.dataset.sfValue;
          this.styleConfig = null; this.checkpoints = []; this.updateHeader(); this.render(true); return;
        }
        if (action === 'apply') { this.apply(); return; }
        if (action === 'style') {
          this.requestId++;
          this.styleConfig = this.catalogue.styles.find(style => style.key === button.dataset.sfValue);
          if (!this.styleConfig) return;
          if (this.styleConfig.external) { window.location.assign(this.styleConfig.url); return; }
          this.answers = {}; this.history = []; this.checkpoints = []; this.step = 0; this.applied = false; this.updateHeader();
        } else if (action === 'choose') {
          const question = this.styleConfig?.questions[this.step];
          if (!question || !this.visibleChoices(question).some(choice => choice.value === button.dataset.sfValue)) return;
          this.clearAnswersFrom(this.step + 1);
          this.checkpoints = this.checkpoints.filter(checkpoint => checkpoint.step <= this.step);
          this.answers[this.styleConfig.questions[this.step].key] = button.dataset.sfValue;
          this.history.push(this.step);
          this.step++;
          this.refreshAvailability(true); return;
        } else if (action === 'back') {
          this.applied = false;
          if (this.history.length) this.step = this.history.pop();
          else if (this.familyMode && this.styleConfig) this.styleConfig = null;
          else if (this.styleConfig && this.step > 0) this.step = 0;
          else if (this.allMode) this.routeFamily = null;
          this.clearAnswersFrom(this.step + 1);
          this.checkpoints = this.checkpoints.filter(checkpoint => checkpoint.step <= this.step);
          this.updateHeader();
        } else if (action === 'edit') {
          this.applied = false; this.answers = {}; this.history = []; this.checkpoints = []; this.step = 0;
        } else if (action === 'restart') {
          this.answers = {}; this.history = []; this.checkpoints = []; this.step = 0; this.applied = false;
          if (this.familyMode) this.styleConfig = null;
        }
        this.refreshAvailability(true);
      });
    }
    text(value) { return this.copy.labels?.[value] || value; }
    node(tag, className, text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text != null) element.textContent = this.text(text);
      return element;
    }
    button(text, action, className) {
      const button = this.node('button', className || 'sf__text-button', text);
      button.type = 'button'; button.dataset.sfAction = action;
      return button;
    }
    icon(name) {
      const source = this.catalogue?.icons?.[name];
      const image = this.node('img', 'sf__icon');
      image.width = 40; image.height = 40; image.alt = '';
      if (source?.url) image.src = source.url;
      else return this.node('span', 'sf__icon-space');
      image.setAttribute('aria-hidden','true');
      return image;
    }
    updateHeader() {
      const family = this.catalogue?.hierarchy.categories.find(item=>item.key===this.routeFamily);
      const config = this.styleConfig || family;
      this.style.setProperty('--sf-colour', (this.styleConfig?.family || this.routeFamily)==='trees' ? '#5eb4e3' : (this.styleConfig?.family || this.routeFamily)==='topiary' ? '#95623f' : '#61a72e');
      const title = this.querySelector('[data-sf-title]');
      if (title) title.textContent = config ? this.copy.styleTitle.replace('[style]', this.text(this.styleConfig?.title || family.label || family.key)) : this.copy.title;
      const subtitle = this.querySelector('[data-sf-subtitle]');
      if (subtitle) subtitle.textContent = this.text(this.styleConfig?.intro || family?.hint || this.copy.intro);
      const holder = this.querySelector('[data-sf-heading-icon]');
      if (holder) holder.replaceChildren(this.icon(this.styleConfig?.key || this.routeFamily || 'other-plants'));
    }
    message(text, retry) {
      this.body.replaceChildren();
      const message = this.node('p', 'sf__status', text);
      message.setAttribute('role', 'status'); this.body.append(message);
      if (retry) this.body.append(this.button(this.copy.retry, 'retry'));
    }
    async load() {
      if (this.loading) return;
      this.loading = true; this.message(this.copy.loading);
      try {
        if (!catalogueRequest) catalogueRequest = fetch(this.dataset.source, { credentials: 'same-origin', signal: AbortSignal.timeout(12000) }).then(response => {
          if (!response.ok) throw new Error('Filters unavailable');
          return response.json();
        }).catch(error => { catalogueRequest = null; throw error; });
        this.catalogue = await catalogueRequest;
        this.styleConfig = this.catalogue.styles.find(style => style.key === this.dataset.style);
        this.familyMode = !this.styleConfig;
        this.allMode = this.dataset.style === 'all' || !this.dataset.family;
        this.routeFamily = this.allMode ? null : this.dataset.family;
        this.updateHeader();
        if (this.styleConfig) {
          const subtitle = this.querySelector('[data-sf-subtitle]');
          if (subtitle) subtitle.textContent = this.text(this.styleConfig.intro);
        }
        if (this.saved && this.saved.style === this.styleConfig?.key) {
          this.answers = window.HarrodQuizFilters.normalizeAnswers(this.styleConfig, this.saved.answers);
          this.applied = true;
        }
        if (this.familyMode || this.applied) this.render();
        else await this.refreshAvailability();
      } catch (_) { this.message(this.copy.error, true); }
      finally { this.loading = false; }
    }
    answersBeforeStep() {
      const answers = {};
      this.styleConfig.questions.slice(0, this.step).forEach(question => { answers[question.key] = this.answers[question.key]; });
      return answers;
    }
    clearAnswersFrom(index) {
      this.styleConfig?.questions.slice(index).forEach(question => { delete this.answers[question.key]; });
    }
    buildUrl(answers, state = this.filterState) {
      const operators = Object.fromEntries((state?.filters || []).map(filter => [filter.param, filter.operator]));
      return window.HarrodQuizFilters.buildFilterUrl(this.baseUrl(), this.styleConfig, answers, {operators});
    }
    resultCount(state, url) { return window.HarrodQuizFilters.countState(state, url); }
    visibleChoices(question) {
      const available = question.choices.filter(choice => this.isAvailable(choice));
      const limit = Number(question.topChoices || question.maxChoices);
      if (!Number.isInteger(limit) || limit < 1) return available;
      const ranked = available.filter(choice => choice.value !== 'any').sort((a,b) => this.queryCounts[b.value] - this.queryCounts[a.value]);
      return ranked.slice(0, limit).concat(available.filter(choice => choice.value === 'any'));
    }
    questionRepeatsParameter(question, prior, state) {
      const selected = window.HarrodQuizFilters.selectedFilters(this.styleConfig, prior);
      const native = new Set(selected.filters.map(filter => filter.param));
      const trees = new Set(selected.treeFilters.map(filter => filter.field));
      return question.choices.some(choice =>
        window.HarrodQuizFilters.filtersForChoice(choice).some(filter => native.has(filter.param) && state.filters.find(field => field.param === filter.param)?.operator !== 'AND') ||
        window.HarrodQuizFilters.treeFiltersForChoice(choice).some(filter => trees.has(filter.field)));
    }
    async fetchAvailability(href, fresh = false) {
      const url = new URL(href);
      url.searchParams.delete('section_id');
      url.searchParams.set('section_id', 'ho-style-filter-state');
      const key = url.href;
      if (fresh) availabilityRequests.delete(key);
      if (!availabilityRequests.has(key)) {
        if (availabilityRequests.size > 40) availabilityRequests.clear();
        availabilityRequests.set(key, fetch(key, {credentials:'same-origin', signal:AbortSignal.timeout(12000)}).then(response => {
          if (!response.ok) throw new Error('Availability unavailable');
          return response.text();
        }).then(html => {
          const element = new DOMParser().parseFromString(html,'text/html').querySelector('[data-ho-style-filter-state]');
          if (!element) throw new Error('Availability unavailable');
          const state = JSON.parse(element.textContent);
          if (!Array.isArray(state.filters) || !Number.isFinite(state.count)) throw new Error('Availability unavailable');
          return state;
        }).catch(error => { availabilityRequests.delete(key); throw error; }));
      }
      return availabilityRequests.get(key);
    }
    async refreshAvailability(focus) {
      const requestId = ++this.requestId;
      if (!this.styleConfig || this.applied) { this.render(focus); return; }
      this.message(this.copy.checking);
      try {
        while (true) {
          const prior = this.answersBeforeStep();
          const result = this.buildUrl(prior);
          const state = await this.fetchAvailability(result.url);
          if (requestId !== this.requestId || !this.isConnected) return;
          this.filterState = state;
          const count = this.resultCount(state, result.url);
          if (count === null) {
            this.message(this.copy.noMoreQuestions);
            this.body.append(this.button(this.copy.viewProducts,'products','sf__view'));
            return;
          }
          if (count === 0 || result.conflicts.length || result.unsupported.length) {
            await this.apply(); return;
          }
          const checkpoint = {answers:{...prior}, history:[...this.history], step:this.step, url:result.url};
          const last = this.checkpoints.at(-1);
          if (last?.url === checkpoint.url) this.checkpoints[this.checkpoints.length - 1] = checkpoint;
          else this.checkpoints.push(checkpoint);
          if (this.history.length >= maxQuestions || this.step >= this.styleConfig.questions.length) {
            if (this.history.length) await this.apply();
            else { this.message(this.copy.noMoreQuestions); this.body.append(this.button(this.copy.viewProducts,'apply','sf__view')); }
            return;
          }
          const question = this.styleConfig.questions[this.step];
          const hasTreeChoices = question.choices.some(choice => window.HarrodQuizFilters.treeFiltersForChoice(choice).length);
          if ((hasTreeChoices && state.treeComplete !== true) || this.questionRepeatsParameter(question, prior, state)) {
            this.answers[question.key] = 'any'; this.step++; continue;
          }
          const counts = {};
          await Promise.all(question.choices.filter(c=>c.value!=='any').map(async choice=>{
            const native = choice.nativeFilters || [];
            const tree = window.HarrodQuizFilters.treeFiltersForChoice(choice);
            const activeTree = Array.from(new URL(result.url).searchParams.keys()).some(key => key.startsWith('ho_tree_') && key !== 'ho_tree_page');
            const priorParams = window.HarrodQuizFilters.selectedFilters(this.styleConfig, prior).filters.map(filter => filter.param);
            if (native.length === 1 && !tree.length && !activeTree && !priorParams.includes(native[0].param) && !new URL(result.url).searchParams.has(native[0].param) && typeof choice.query !== 'string') {
              const field = state.filters.find(f=>f.param===native[0].param);
              counts[choice.value] = field?.values.find(v=>String(v.value)===String(native[0].value))?.count || 0;
            } else if (native.length || tree.length || typeof choice.query === 'string') {
              const next = this.buildUrl({...prior,[question.key]:choice.value}, state);
              if (next.unsupported.length || next.conflicts.length) counts[choice.value] = 0;
              else {
                const nextState = await this.fetchAvailability(next.url);
                counts[choice.value] = this.resultCount(nextState, next.url) ?? 0;
              }
            } else counts[choice.value] = 0;
          }));
          if (requestId !== this.requestId || !this.isConnected) return;
          this.queryCounts = counts;
          const useful = Object.values(counts).some(choiceCount=>choiceCount>0 && choiceCount<count);
          if (useful) { this.render(focus); return; }
          this.answers[question.key] = 'any'; this.step++;
        }
      } catch (_) {
        if (requestId !== this.requestId) return;
        this.message(this.copy.availabilityError);
        this.body.append(this.button(this.copy.retry,'retry-availability'));
      }
    }
    isAvailable(choice) {
      return choice.value === 'any' || this.queryCounts?.[choice.value] > 0;
    }
    render(focus) {
      if (!this.catalogue) return;
      this.body.replaceChildren();
      const top = this.node('div', 'sf__top');
      const questions = this.styleConfig?.questions || [];
      const label = this.applied ? this.copy.applied : this.copy.questionNumber.replace('[current]',this.history.length + 1);
      if (this.styleConfig && questions.length) top.append(this.node('span', 'sf__position', label));
      else top.classList.add('sf__top--choose');
      const controls = this.node('div', 'sf__controls');
      if (!this.applied && (this.history.length || (this.styleConfig && this.familyMode) || (this.allMode && this.routeFamily))) controls.append(this.button(this.copy.back, 'back'));
      controls.append(this.button(this.copy.close, 'close')); top.append(controls); this.body.append(top);
      if (this.styleConfig?.external) {
        const link = this.node('a', 'sf__view', this.copy.existingFinder);
        link.href = this.styleConfig.url; this.body.append(link); return;
      }
      if (this.styleConfig && !questions.length) {
        this.body.append(this.node('p', 'sf__status', this.copy.browseOnly), this.button(this.copy.viewProducts, 'products', 'sf__view'));
        return;
      }
      if (this.applied) { this.renderApplied(focus); return; }
      const question = this.styleConfig ? questions[this.step] : null;
      const route = this.routeFamily ? this.catalogue.hierarchy.categories.find(item=>item.key===this.routeFamily) : this.catalogue.hierarchy.entry;
      const heading = this.node('h3', 'sf__question', question ? question.title : route?.title || this.copy.chooseStyle);
      heading.tabIndex = -1;
      this.body.append(heading);
      const hint = question ? question.hint : route?.hint;
      if (hint) this.body.append(this.node('p','sf__hint',hint));
      if (this.styleConfig?.advisory) this.body.append(this.node('p','sf__advisory',this.styleConfig.advisory));
      const choices = this.node('div', 'sf__choices');
      choices.setAttribute('role', 'group'); choices.setAttribute('aria-label', heading.textContent);
      const options = question ? this.visibleChoices(question) : route?.choices || [];
      if (!question) choices.classList.add('sf__choices--routes');
      options.forEach(choice => {
        const button = this.button('', question ? 'choose' : this.routeFamily ? 'style' : 'category', 'sf__choice');
        button.dataset.sfValue = choice.value;
        if (question) button.setAttribute('aria-pressed', String(this.answers[question.key] === choice.value));
        const words = this.node('span', 'sf__choice-copy');
        words.append(this.node('span', 'sf__choice-label', choice.label));
        if (choice.detail) words.append(this.node('small', '', choice.detail));
        const nativeIcon = (choice.nativeFilters || []).map(filter=>filter.param + '|' + filter.value).find(key=>this.catalogue.icons?.[key]);
        button.append(this.icon(nativeIcon || choice.icon), words); choices.append(button);
      });
      this.body.append(choices);
      if (question) this.body.append(this.node('p', 'sf__footnote', this.copy.applyNote));
      if (question && options.every(choice=>choice.value==='any')) this.body.append(this.node('p','sf__footnote',this.copy.noFurtherChoice));
      if (focus) heading.focus({ preventScroll: true });
    }
    baseUrl() {
      const url = new URL(window.location.href);
      if (this.familyMode) {
        Array.from(url.searchParams.keys()).forEach(key=>{ if (key.startsWith('filter.') || key.startsWith('ho_')) url.searchParams.delete(key); });
        url.searchParams.delete('q'); url.searchParams.delete('type');
      }
      if (this.styleConfig.search) {
        url.pathname = this.dataset.root + 'search';
        url.searchParams.set('type','product');
        url.searchParams.delete('filter.p.product_type');
        (this.styleConfig.values || []).forEach(value => url.searchParams.append('filter.p.product_type', value));
      }
      const usesTreeFilters = this.styleConfig.questions.some(question => question.choices.some(choice => window.HarrodQuizFilters.treeFiltersForChoice(choice).length));
      if (!this.styleConfig.search && (this.familyMode || this.dataset.resultsPath || usesTreeFilters)) {
        url.pathname = usesTreeFilters ? this.dataset.root + 'collections/all' : this.dataset.resultsPath || this.dataset.root + 'collections/all';
        url.searchParams.delete('filter.p.product_type');
        (this.styleConfig.values || []).forEach(value => url.searchParams.append('filter.p.product_type', value));
        ['ho_category', 'ho_search_category', 'ho_tree_page'].forEach(key => url.searchParams.delete(key));
      }
      url.hash = '';
      return url.href;
    }
    async apply() {
      if (!window.HarrodQuizFilters) { this.message(this.copy.error, true); return; }
      if (this.applying) return;
      this.applying = true;
      const requestId = ++this.requestId;
      const current = {answers:this.answersBeforeStep(), history:[...this.history], step:this.step};
      const candidates = [current, ...this.checkpoints.slice().reverse()];
      const checked = new Set();
      let confirmed;
      this.message(this.copy.checking);
      try {
        for (const candidate of candidates) {
          const result = this.buildUrl(candidate.answers);
          if (checked.has(result.url) || result.unsupported.length || result.conflicts.length) continue;
          checked.add(result.url);
          const state = await this.fetchAvailability(result.url, true);
          if (requestId !== this.requestId || !this.isConnected) return;
          const count = this.resultCount(state, result.url);
          if (count !== null && count > 0) { confirmed = {...candidate, result}; break; }
        }
        if (!confirmed) {
          this.message(this.copy.noMatches);
          this.body.append(this.button(this.copy.back,'back'));
          return;
        }
      } catch (_) {
        if (requestId !== this.requestId) return;
        this.message(this.copy.availabilityError);
        this.body.append(this.button(this.copy.retry,'retry-availability'));
        return;
      } finally { this.applying = false; }
      this.answers = confirmed.result.answers;
      this.history = confirmed.history;
      this.step = confirmed.step;
      this.applied = true;
      const page = pageKey(confirmed.result.url);
      saveState(stateKey, { style: this.styleConfig.key, answers: this.answers, page });
      if (page === pageKey(window.location.href)) { this.render(true); scrollToProducts(); return; }
      saveState(scrollKey, { page });
      this.message(this.copy.applying);
      window.location.assign(confirmed.result.url);
    }
    renderApplied(focus) {
      const selected = window.HarrodQuizFilters.selectedFilters(this.styleConfig, this.answers);
      const heading = this.node('h3', 'sf__question', this.copy.applied);
      heading.tabIndex = -1;
      this.body.append(heading, this.node('p', 'sf__status', this.copy.appliedNote));
      if (selected.filters.length || selected.treeFilters.length) {
        const list = this.node('ul', 'sf__applied');
        [...new Set([...selected.filters, ...selected.treeFilters].map(filter => filter.label || filter.value))].forEach(label => list.append(this.node('li', '', label)));
        this.body.append(list);
      }
      this.body.append(this.button(this.copy.edit, 'edit'), this.node('span', 'sf__separator', '·'), this.button(this.copy.viewProducts, 'products'));
      if (focus) heading.focus({ preventScroll: true });
    }
  });
})();



